import { PHASE_LABELS, type Phase } from '../../api/types';
import { describeMissingConcepts } from './phaseConformityConcepts';

const PHASE_DOCUMENT_LABELS: Partial<Record<Phase, string>> = {
  'gerando-prd': 'PRD',
  'gerando-techspec': 'TechSpec',
  'dividindo-tasks': 'plano de tasks',
  qa: 'relatório de QA',
  pronto: 'entrega',
};

export interface PhaseConformityRepairNotice {
  phase: Phase;
  content: string;
}

export function buildPhaseConformityRepairNotice(
  eventPhase: string | undefined,
  currentPhase: Phase,
  missingConcepts?: readonly string[],
): PhaseConformityRepairNotice {
  const phase = isPhase(eventPhase) ? eventPhase : currentPhase;
  const documentLabel = PHASE_DOCUMENT_LABELS[phase] ?? 'documento da fase';
  const pending = describeMissingConcepts(phase, missingConcepts);
  const suffix =
    pending.length > 0 ? ` Pendências: ${pending.join('; ')}.` : '';
  return {
    phase,
    content: `O agente está ajustando o ${documentLabel} para atender aos critérios obrigatórios.${suffix}`,
  };
}

export function isPhaseConformityRepairNoticeCurrent(
  notice: PhaseConformityRepairNotice & { activityId: string },
  activityId: string | undefined,
  currentPhase: Phase | undefined,
  selectedPhase: Phase,
): boolean {
  return (
    notice.activityId === activityId &&
    notice.phase === currentPhase &&
    notice.phase === selectedPhase
  );
}

function isPhase(value: string | undefined): value is Phase {
  return Boolean(value && value in PHASE_LABELS);
}
